import Http from './http'

export const getQuests = async ({ student_id }) => {
  const data = await Http.get(`/students/${student_id}/quests`)
  return data.data
}
export const getQuest = async ({ quest_id }) => {
  const data = await Http.get(`/quests/${quest_id}`)
  return data.data
}
